import { Container, Grid, Typography } from "@mui/material";
import PermissionGuard from "../../../../../components/PermissionGuard";
import ScreenBanner from "../../../../../components/ScreenBanner";
import Listagem from "./Listagem";
import { useState } from "react";
import DialogAdicionarCupom from "../DialogAdicionarCupom";
import { ConfirmProvider } from "material-ui-confirm";

export default function ListarCupons() {

    const [openAdicionarCupom, setOpenAdicionarCupom] = useState(false);

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.cupons-listar">
                <Container maxWidth="lg" sx={{ mt: 5 }}>
                    <Typography textAlign="center" variant="h5" mb={3}>
                        Cupons e descontos
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid size={{ xs: 12 }}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Excluir item',
                                    cancellationText: "Cancelar",
                                    confirmationText: "Excluir",
                                    confirmationButtonProps: { variant: 'contained', color: 'error' }
                                }}>
                                    <Listagem />
                                </ConfirmProvider>
                        </Grid>
                    </Grid>
                </Container>
                {
                    openAdicionarCupom &&
                    <DialogAdicionarCupom
                        open={openAdicionarCupom}
                        handleClose={() => {
                            setOpenAdicionarCupom(false);
                        }}
                    />
                }
            </PermissionGuard>
        </>
    )
}

